/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'financialStatus/great': {
    width: 42,
    height: 42,
    viewBox: '0 0 42 42',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" d="M20.742 0c11.456 0 20.742 9.286 20.742 20.742 0 11.454-9.286 20.741-20.742 20.741C9.287 41.483 0 32.197 0 20.743 0 9.285 9.287 0 20.742 0" _fill="#FFD735"/><path pid="1" d="M20.936 32.705c-6.04 0-9.998-3.243-10.936-6.698V26v.007c7.67 1.851 14.599 1.868 21.873 0V26v.007c-.938 3.454-4.897 6.698-10.937 6.698M14 13c1.657 0 3 1.837 3 4.1 0 .686-.123 1.332-.342 1.9-.501-1.307-1.504-2.2-2.659-2.2-1.153 0-2.156.893-2.657 2.2A5.308 5.308 0 0111 17.1c0-2.263 1.343-4.1 3-4.1M27 13c1.657 0 3 1.837 3 4.1 0 .686-.123 1.332-.342 1.9-.5-1.307-1.504-2.2-2.658-2.2-1.155 0-2.158.893-2.66 2.2a5.358 5.358 0 01-.34-1.9c0-2.263 1.342-4.1 3-4.1" _fill="#7D5C2A"/></g>'
  }
})
